// removed by extract-text-webpack-plugin
module.exports = {"title":"_16ZhZ","signup":"_1vOSZ"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Login/components/LoginLayout/LoginLayout.scss
// module id = 1169
// module chunks = 15